<script>
// Import Swiper Vue.js components
import { Navigation, Pagination } from "swiper";
import { SwiperCore, Swiper, SwiperSlide } from "swiper-vue2";

// Import Swiper styles
import "swiper/swiper-bundle.css";

SwiperCore.use([Navigation, Pagination]);

import VideoCarouselSlide from "./VideoCarouselSlide.vue";

// Import Swiper styles
//import "swiper/swiper.scss";
//import "swiper/modules/pagination/pagination.scss";

export default {
  components: {
    Swiper,
    SwiperSlide,
    VideoCarouselSlide,
  },
  props: {
    slides: {
      required: true,
    },
    surface: {
      type: String,
      default: "",
    },
    aspectRatio: {
      type: String,
      default: "wide",
    },
  },
  data() {
    return {
      swiper: {},
      activeVideo: 0,
      activeSlide: 0,
      loadVideoWitness: false,
    };
  },
  // setup() {
  //   return {
  //     modules: [Pagination],
  //   };s

  mounted() {
    window.addEventListener("resize", _.debounce(this.setVideoSize, 500));
    // window.on("resize", _.debounce(this.setVideoSize));
  },

  methods: {
    setInitialSize(vHeight) {
      if (this.loadVideoWitness === false) {
        const carousel = this.$refs.carousel.$el;
        carousel.style.setProperty("--slide-video-h", `${vHeight}px`);
        this.loadVideoWitness = true;
      }
    },
    setVideoSize() {
      if (window.innerWidth < 1200) {
        const videoOnSlides = document.querySelector(".carouselVideo");
        const carousel = this.$refs.carousel.$el;
        carousel.style.setProperty(
          "--slide-video-h",
          `${videoOnSlides.getBoundingClientRect().height}px`
        );
      }
    },
    onSlideChange(swiper) {
      this.activeSlide = swiper.activeIndex;
    },
    onVideoChange(index) {
      this.activeVideo = index;
    },

    onSwiper(swiper) {
      this.swiper = swiper;
    },
    changeVideo() {
      this.activeVideo = this.swiper.activeIndex;
    },
    surfacePicker() {
      if (this.surface === "dark") {
        return "vw-dark-surface";
      } else if (this.surface === "darkest") {
        return "vw-darkest-surface";
      } else {
        return "";
      }
    },
    generateStyles() {
      if (this.aspectRatio === "wide") {
        return {
          "--video-ratio": "16/9",
        };
      } else if (this.aspectRatio === "square") {
        return {
          "--video-ratio": "1/1",
        };
      }
    },
  },
  watch: {
    // activeVideo() {
    //   this.activeSlide = this.activeVideo;
    // },
  },
};
</script>
<template>
  <!-- <CarouselVideo :active-video="activeVideo" /> -->
  <swiper
    :slidesPerView="1"
    :spaceBetween="0"
    :centeredSlides="true"
    :loop="false"
    :maxBackfaceHiddenSlides="1"
    :pagination="{
      clickable: true,
    }"
    @swiper="onSwiper"
    @slideChange="changeVideo"
    @slideChangeTransitionStart="isTransitionFinished = false"
    @slideChangeTransitionEnd="isTransitionFinished = true"
    class="mySwiper"
    ref="carousel"
    :style="generateStyles()"
    :class="surfacePicker()"
  >
    <swiper-slide v-for="(slide, index) in slides" :key="index">
      <VideoCarouselSlide
        :slide-index="index"
        :slide="slide"
        :active-slide="activeVideo"
        @video-loaded="setInitialSize"
      />
    </swiper-slide>
  </swiper>
</template>

<style>
.swiper {
  --slide-video-h: 300px;
  background-color: var(--background-color);
  color: var(--text-color);
  width: 100%;
  margin-left: 00%;
  height: 100%;
  overflow-x: hidden;
  margin-top: 0;
  padding-top: 0px;
  padding-bottom: 0px;
}

.swiper-slide {
  align-items: center;
  display: flex;
  font-size: 18px;
  height: 100%;
  justify-content: center;
  opacity: 0.75;
  text-align: center;
  transform-origin: center center;
  transform: scale(0.8);
  transition: all 0.5s;
}
.swiper-slide-active {
  opacity: 1;
  transform: scale(1);
}

.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.swiper-pagination,
.swiper-pagination {
  --indicator-color: var(--lighter-gray);
  --indicator-fill: transparent;
}
.vw-dark-surface .swiper-pagination,
.vw-dark-surface .swiper-pagination {
  --indicator-color: white;
  --indicator-fill: transparent;
}

.swiper-pagination-bullet {
  width: 12px;
  height: 12px;
  border: 1px solid var(--lighter-gray);
  background: var(--indicator-fill);
  opacity: 1;
  top: var(--slide-video-h);
}
.swiper-pagination-bullet-active {
  background: var(--indicator-color);
  opacity: 1;
}
.swiper-pagination-bullets {
  top: calc(var(--slide-video-h) + 30px) !important;
  bottom: unset !important;
}
</style>



// WEBPACK FOOTER //
// resources/assets/vuejs/frontend/2023-launch/components/VideoCarousel.vue